import React, { useEffect, useRef, useState } from "react";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import { useFormik } from "formik";
import { signatureBuilderSchema } from "../Schemas/ChangePassword";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useLocation, useHistory } from "react-router-dom";
import { ArrowLeft } from "@material-ui/icons";
import { ArrowBack } from "@mui/icons-material";
const SignatureBuilder = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const state = location.state;
  const history = useHistory();
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  // const [copied, setCopied] = useState(false);
  const divRef = useRef(null);
  // const copyAsHTML = () => {
  //   setCopied(true);
  //   const div = divRef.current;
  //   if (div) {
  //     const range = document.createRange();
  //     range.selectNode(div);
  //     window.getSelection().removeAllRanges();
  //     window.getSelection().addRange(range);

  //     const el = document.createElement("textarea");
  //     el.value = div.outerHTML;
  //     document.body.appendChild(el);
  //     el.select();
  //     document.execCommand("copy");
  //     document.body.removeChild(el);

  //     window.getSelection().removeAllRanges();
  //     setTimeout(() => {
  //       setCopied(false);
  //     }, 1500);
  //     // alert("HTML copied to clipboard!");
  //   }
  // };

  const handleFormSubmit = (values, actions) => {
    const div = divRef.current;
    axios
      .put(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-from-email/update-email-signature/${
          userDetails && userDetails.details._id
        }/${location.pathname.split("/")[2]}`,
        {
          signature: div.outerHTML,
          signatureFields: {
            name: values.name,
            lastName: values.lastName,
            jobTitle: values.jobTitle,
            department: values.department,
            company: values.company,
            phoneNumber: values.phoneNumber,
            websiteURL: values.websiteURL,
            emailAddress: values.emailAddress,
            businessAddress: values.businessAddress,
            photoURL: values.photoURL,
            linkedin: values.linkedin,
            facebook: values.facebook,
            twitter: values.twitter,
            instagram: values.instagram,
          },
        },
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.status) {
          toast.success(response.data.message);
          setTimeout(() => {
            history.goBack();
          }, 2000);
          actions.resetForm();
        }
      })
      .catch((error) => {
        console.log(error.message);
        toast.error(error.message);
      });
  };
  const {
    values,
    errors,
    touched,
    dirty,
    setValues,
    handleBlur,
    handleChange,
    handleSubmit,
    handleReset,
  } = useFormik({
    initialValues: state,
    validationSchema: signatureBuilderSchema,
    onSubmit: handleFormSubmit,
  });
useEffect(()=>{
  if(location.pathname.split("/")[3].toString()==="update"){
    setValues({ ...values, forceChange: true });
  }

},[])
  // useEffect(() => {
  //   axios
  //     .get(
  //       `${BaseUrl.baseurl}/email-marketing/user/get-user-signature/${
  //         userDetails && userDetails.details._id
  //       }`,
  //       {
  //         headers: {
  //           Authorization: `Bearear ${userDetails && userDetails.token}`,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.status) {
  //         // console.log("response----------->", response);
  //         // toast.success(response.data.message);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error.message);
  //       toast.error(error.message);
  //     });
  // }, []);

  return (
    <div
      style={{
        padding: "12px 10px 12px 14px",
        height: "100%",
        overflow: "auto",
        position: "relative",
        backgroundColor: "#FFF",
        border: "1px solid #DDD",
        borderRadius: 5,
      }}
      className="grid grid-cols-2 gap-3"
    >
      {/* form container */}
      <form
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: 12 }}
        className="space-y-2"
      >
        <div
          style={{
            // boxShadow:
            //   "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
            borderRadius: 5,
          }}
          className="space-y-2"
        >
          <div>
            <p
              style={{
                fontWeight: 700,
                color: "#1C485F",
                fontSize: "24px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span
                onClick={() => history.goBack()}
                style={{ cursor: "pointer" }}
              >
                <ArrowBack />
                Signature details
              </span>
              <Tooltip
                title={`You are trying to add a signature to this ${email} email address.`}
                arrow
              >
                <HelpOutlineIcon />
              </Tooltip>
            </p>
            <span
              style={{
                fontWeight: 400,
                color: "#868686",
                fontSize: "15px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Enter your personal & business data
            </span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="name"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                First Name
              </label>
              <input
                type="text"
                placeholder="Enter your name"
                value={values.name}
                onChange={handleChange}
                onBlur={handleBlur}
                id="name"
                name="name"
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.name && touched.name && (
                <p style={{ color: "red", marginTop: "0px" }}>{errors.name}</p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="lastName"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Last Name
              </label>
              <input
                type="text"
                placeholder="Enter your lastName"
                value={values.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
                id="lastName"
                name="lastName"
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.lastName && touched.lastName && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.lastName}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="jobTitle"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Job Title
              </label>
              <input
                type="text"
                placeholder="Enter your job title"
                value={values.jobTitle}
                onChange={handleChange}
                onBlur={handleBlur}
                id="jobTitle"
                name="jobTitle"
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.jobTitle && touched.jobTitle && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.jobTitle}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="department"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Department
              </label>
              <input
                type="text"
                placeholder="Enter your department"
                value={values.department}
                onChange={handleChange}
                onBlur={handleBlur}
                id="department"
                name="department"
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.department && touched.department && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.department}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="company"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Company
              </label>
              <input
                type="text"
                placeholder="Enter your company"
                value={values.company}
                onChange={handleChange}
                onBlur={handleBlur}
                id="company"
                name="company"
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.company && touched.company && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.company}
                </p>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            // boxShadow:
            //   "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
            borderRadius: 5,
          }}
          className="space-y-2"
        >
          <div>
            <p
              style={{
                fontWeight: 700,
                color: "#1C485F",
                fontSize: "24px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Contact Information
            </p>
            <span
              style={{
                fontWeight: 400,
                color: "#868686",
                fontSize: "15px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Enter your contact details. Stay connected.
            </span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="phoneNumber"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Phone Number
              </label>
              <input
                type="text"
                placeholder="Enter your phoneNumber"
                id="phoneNumber"
                name="phoneNumber"
                value={values.phoneNumber}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.phoneNumber && touched.phoneNumber && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.phoneNumber}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="websiteURL"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Website URL
              </label>
              <input
                type="text"
                placeholder="Enter your websiteURL"
                id="websiteURL"
                name="websiteURL"
                value={values.websiteURL}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.websiteURL && touched.websiteURL && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.websiteURL}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="emailAddress"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Email Address
              </label>
              <input
                type="text"
                placeholder="Enter your emailAddress"
                id="emailAddress"
                name="emailAddress"
                value={values.emailAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.emailAddress && touched.emailAddress && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.emailAddress}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="businessAddress"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Business Address
              </label>
              <input
                type="text"
                placeholder="Enter your businessAddress"
                id="businessAddress"
                name="businessAddress"
                value={values.businessAddress}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.businessAddress && touched.businessAddress && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.businessAddress}
                </p>
              )}
            </div>
          </div>
        </div>
        <div
          style={{
            // boxShadow:
            //   "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
            borderRadius: 5,
          }}
          className="space-y-2"
        >
          <div>
            <div>
              <p
                style={{
                  fontWeight: 700,
                  color: "#1C485F",
                  fontSize: "24px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Add Photo
              </p>
              <span
                style={{
                  fontWeight: 400,
                  color: "#868686",
                  fontSize: "15px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                  justifyContent: "space-between",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                Upload your photo or logo
                <Tooltip
                  title="Upload an image to your Dropbox,Google Drive or a similar site and paste the URL here. The file size should not exceed 3 MB"
                  arrow
                  placement="right"
                >
                  <HelpOutlineIcon />
                </Tooltip>
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 2,
                padding: "6px 0px",
              }}
            >
              <label
                htmlFor="photoURL"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Photo URL
              </label>
              <input
                type="text"
                placeholder="Enter your photoURL"
                id="photoURL"
                name="photoURL"
                value={values.photoURL}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.photoURL && touched.photoURL && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.photoURL}
                </p>
              )}
            </div>
          </div>
          <div>
            <p
              style={{
                fontWeight: 700,
                color: "#1C485F",
                fontSize: "24px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Social Media links
            </p>
            <span
              style={{
                fontWeight: 400,
                color: "#868686",
                fontSize: "15px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              You can provide links to your own or corporate social networks
            </span>
          </div>
          <div className="grid grid-cols-2 gap-2">
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="linkedin"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Linkedin
              </label>
              <input
                type="text"
                placeholder="https://www.linkedin.com/"
                id="linkedin"
                name="linkedin"
                value={values.linkedin}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.linkedin && touched.linkedin && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.linkedin}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="facebook"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Facebook
              </label>
              <input
                type="text"
                placeholder="https://www.facebook.com/"
                id="facebook"
                name="facebook"
                values={values.facebook}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.facebook && touched.facebook && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.facebook}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="twitter"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Twitter
              </label>
              <input
                type="text"
                placeholder="https://www.twitter.com/"
                id="twitter"
                name="twitter"
                values={values.twitter}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.twitter && touched.twitter && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.twitter}
                </p>
              )}
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <label
                htmlFor="instagram"
                style={{
                  fontWeight: 600,
                  color: "#1C485F",
                  fontSize: "16px",
                  letterSpacing: "0.7px",
                  fontFamily: "Source Sans 3",
                  fontStyle: "normal",
                }}
              >
                Instagram
              </label>
              <input
                type="text"
                placeholder="https://www.instagram.com/"
                id="instagram"
                name="instagram"
                value={values.instagram}
                onChange={handleChange}
                onBlur={handleBlur}
                style={{
                  border: "1px solid #1C485F",
                  padding: "8px 4px",
                  outline: "none",
                  borderRadius: 4,
                }}
              />
              {errors.instagram && touched.instagram && (
                <p style={{ color: "red", marginTop: "0px" }}>
                  {errors.instagram}
                </p>
              )}
            </div>
          </div>
        </div>
        <button
          type="submit"
          style={{
            backgroundColor: "#FF3301",
            color: "#FFF",
            padding: "14px 24px",
            outline: "none",
            borderRadius: 5,
          }}
        >
          Create Signature
        </button>
      </form>
      {/* preview box container */}
      <div
        className="space-y-3"
        style={{ position: "sticky", top: 0, height: "max-content" }}
      >
        <div
          style={{
            border: "1px solid #1C485F",
            borderRadius: 5,
          }}
        >
          <div>
            <div
              style={{ borderBottom: "1px solid #1C485F", padding: "4px 10px" }}
            >
              <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <b>Send:</b>
                Elon Musk
              </span>
            </div>
            <div
              style={{ borderBottom: "1px solid #1C485F", padding: "4px 10px" }}
            >
              <span style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <b>Subject:</b>
                Hello Tesla 👋
              </span>
            </div>
          </div>
          <div
            style={{
              padding: 10,
            }}
          >
            <p
              style={{
                fontWeight: 400,
                color: "#868686",
                fontSize: "15px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              I ran into a problem with my email.
            </p>
            <p
              style={{
                fontWeight: 400,
                color: "#868686",
                fontSize: "15px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              I sent emails to my clients to announce the launch of a new
              promotion in our company, but most of the recipients received my
              emails in the SPAM folder.
            </p>
            <p
              style={{
                fontWeight: 400,
                color: "#868686",
                fontSize: "15px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Perhaps this is due to the fact that my domain is very young and
              has not participated in mailing lists before?
            </p>
            <p
              style={{
                fontWeight: 400,
                color: "#868686",
                fontSize: "15px",
                letterSpacing: "0.7px",
                fontFamily: "Source Sans 3",
                fontStyle: "normal",
              }}
            >
              Could you tell me how I can warm up my domain and mailbox?
            </p>
          </div>
         <div style={{paddingLeft:10}}>
          <div
            ref={divRef}
            dangerouslySetInnerHTML={{
              __html: `<div style="padding:10px 10px 10px 0px ; display:${ dirty ? values.photoURL === ""? "":"flex":"flex"}">
 <div style="flex-shrink: 0;margin-right:14px">
      ${
        dirty && values.photoURL === ""
          ? ""
          : `<img src="${
              values.photoURL === ""
                ? "https://justscheduler.in-maa-1.linodeobjects.com/photo.png"
                : values.photoURL
            }" style="height: 100px; width: 100px; border-radius: 100%;" />`
      }
     
     <div style="display: flex;  align-items: center; padding: 6px 0px;">
         <div>
         ${
           dirty && values.linkedin === ""
             ? ""
             : `<a href="${
                 values.linkedin === ""
                   ? "https://www.linkedin.com"
                   : values.linkedin
               }" target="_blank" style="text-decoration: none;"><img src="https://justscheduler.in-maa-1.linodeobjects.com/icons8-linkedin-50.png" alt="linkedin" style="height: 25px; width: 25px;"></a>`
         }
         </div>
         <div>
         ${
           dirty && values.facebook === ""
             ? ""
             : `<a href="${
                 values.facebook === ""
                   ? "https://www.facebook.com/"
                   : values.facebook
               }" target="_blank" style="text-decoration: none;"><img src="https://justscheduler.in-maa-1.linodeobjects.com/icons8-facebook-50.png" alt="facebook" style="height: 25px; width: 25px;"></a>`
         }         
         </div>
         <div>
         ${
           dirty && values.twitter === ""
             ? ""
             : `<a href="${
                 values.twitter === "" ? "https://twitter.com/" : values.twitter
               }" target="_blank" style="text-decoration: none;"><img src="https://justscheduler.in-maa-1.linodeobjects.com/icons8-twitter-48.png" alt="facebook" style="height: 25px; width: 25px;"></a>`
         }
         </div>
         <div>
         ${
           dirty && values.instagram === ""
             ? ""
             : `<a href="${
                 values.instagram === ""
                   ? "https://www.instagram.com/"
                   : values.instagram
               }" target="_blank" style="text-decoration: none;"><img src="https://justscheduler.in-maa-1.linodeobjects.com/icons8-instagram-50.png" alt="facebook" style="height: 25px; width: 25px;"></a>`
         }         
         </div>
     </div>
 </div>
 <div class="details" style="flex-grow: 1; padding: ${values.photoURL === ""?"6px 6px 6px 0px":"6px"}; text-align: left;">
     <p style="font-weight: 700; color: rgb(28, 72, 95); font-size: 18px; letter-spacing: 0.7px; font-style: normal; margin: 1px 0px;">${
       dirty && values.name === ""
         ? ""
         : values.name === ""
         ? "Jhon Doe"
         : values.name + " " + values.lastName
     }</p>
     ${
       dirty &&
       values.jobTitle === "" &&
       dirty &&
       values.department === "" &&
       dirty &&
       values.company === ""
         ? ""
         : `<div style="font-weight: 500; color: rgb(28, 72, 95); font-size: 13px; letter-spacing: 0.7px; font-style: normal;">
     <span>${
       dirty && values.jobTitle === ""
         ? ""
         : values.jobTitle === ""
         ? "Manager"
         : values.jobTitle
     }</span> ${values.jobTitle !== "" ? "<br>" : ""}
     <span>${
       dirty && values.department === ""
         ? ""
         : values.department === ""
         ? "Marketing"
         : values.department
     }</span>${values.department !== "" ? "<br>" : ""}
     <span>${
       dirty && values.company === ""
         ? ""
         : values.company === ""
         ? "Company"
         : values.company
     }</span>
 </div>`
     }
     
     <div style="font-weight: 400; color: rgb(134, 134, 134); font-size: 12px; letter-spacing: 0.7px; font-style: normal;">
         <p style="margin: 1px 0px;display:flex">
         ${
           dirty && values.emailAddress === ""
             ? " "
             : `<img src="https://justscheduler.in-maa-1.linodeobjects.com/icons8-mail-24.png" alt="email-cover" style="height: 18px; width: 18px;margin-right:5px">${
                 values.emailAddress === ""
                   ? "example@coldsender.com"
                   : values.emailAddress
               }`
         }
         </p>
         <p style="margin: 1px 0px;display:flex;">
         ${
           dirty && values.phoneNumber === ""
             ? " "
             : `<img src="https://justscheduler.in-maa-1.linodeobjects.com/icons8-phone-32.png" alt="phone" style="height: 18px; width: 18px;margin-right:5px">${
                 values.phoneNumber === "" ? "0000000000" : values.phoneNumber
               }`
         }
         </p>
         <p style="margin: 1px 0px;display:flex;">
         ${
           dirty && values.websiteURL === ""
             ? " "
             : `<img src="https://justscheduler.in-maa-1.linodeobjects.com/icons8-website-24.png" alt="web" style="height: 18px; width: 18px;margin-right:5px">${
                 values.websiteURL === ""
                   ? "example@cold.com"
                   : values.websiteURL
               }`
         }
         </p>
         <p style="margin: 1px 0px;display:flex;">
         ${
           dirty && values.businessAddress === ""
             ? " "
             : `<img src="https://justscheduler.in-maa-1.linodeobjects.com/icons8-location-48.png" alt="location" style="height: 18px; width: 18px;margin-right:5px">
          ${
            values.businessAddress === ""
              ? "Address21,City"
              : values.businessAddress
          }`
         }
         </p>
     </div>
 </div>
</div>`,
            }}
          />
          </div>
        </div>
        {/* <button
          onClick={() => copyAsHTML()}
          style={{
            backgroundColor: "transparent",
            border: "1px solid #FF3301",
            color: "#FF3301",
            padding: "14px 24px",
            borderRadius: 6,
            outline: "none",
            fontSize: "14px",
            letterSpacing: "0.7px",
            fontFamily: "Source Sans 3",
            fontStyle: "normal",
            ":hover": {
              backgroundColor: "#fc9db5",
            },
          }}
        >
          {!copied ? "Copy as HTML" : "Copied"}
        </button> */}
      </div>
      <ToastContainer />
    </div>
  );
};

export default SignatureBuilder;
